import {alias, createModelSchema, custom, deserialize, list, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";

export class ItemShopProduct extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && v.valid() ? serialize(ItemShopProduct, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemShopProduct, v);
            }
        );
    }

    constructor() {
        super();
        this._key = null;
        this._name = null;
        this._price = [];
        this._reward = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get price() {
        return this._price;
    }

    set price(value) {
        this._price = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {

        if (this.price && this.price.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return !this.reward || this.price.length === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemShopProduct());
        } else if (target instanceof ItemShopProduct) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemShopProduct, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _price: alias("price", list(Currency.schema())),
    _reward: alias("reward", RewardModel.schema())
});